// Apoio da troca de e-mail com validação (modal Alterar e-mail).

const GENERICO = "Não foi possível alterar o e-mail. Verifique o endereço e tente novamente.";

// Resposta de erro da API -> { mensagem, codigo, tentativasRestantes, brando }.
// `brando` = situação que não é erro de quem digitou (expirou, pedido encerrado, limite):
// a tela mostra um aviso calmo orientando a pedir outro código, não um vermelho de erro.
export function lerErro(result) {
  const resposta = result && result.response;
  const dados = (resposta && resposta.data) || {};
  const codigo = dados.codigo_erro || null;
  return {
    status: resposta ? resposta.status : 0,
    mensagem: dados.error || dados.message || (resposta ? GENERICO : "Sem conexão com o servidor. Verifique sua internet e tente de novo."),
    codigo,
    tentativasRestantes: typeof dados.tentativas_restantes === "number" ? dados.tentativas_restantes : null,
    brando: ["EXPIRADO", "TENTATIVAS_ESGOTADAS", "SEM_PEDIDO"].includes(codigo) || (resposta && resposta.status === 429),
  };
}

// Só dígitos, no máximo 6 (colar "123 456" ou "123-456" funciona).
export function soDigitos(texto, max = 6) {
  return String(texto || "").replace(/\D/g, "").slice(0, max);
}

export function emailValido(texto) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(texto || "").trim());
}

// Guarda o usuário devolvido pela confirmação (com o token NOVO: o antigo carrega o e-mail
// velho e deixa de valer) na sessão do navegador.
export function guardarSessao(usuario) {
  try {
    sessionStorage.setItem("usuario", JSON.stringify(usuario));
  } catch (e) {
    /* sessão indisponível: a store ainda recebe o usuário */
  }
}
